import React, { useState, useEffect } from 'react';
import R from 'ramda';

import CryptoJS from 'crypto-js';

import { useDispatch, useSelector } from 'react-redux';

import Image from 'react-bulma-companion/lib/Image';

import lockImage from "_assets/icons/lock-icon-green.svg";

const secretKey = process.env.SECURE_FIELD_KEY;

export default function SecureText({ id, updateValue, required, label, autoFocus, placeholder, name, classes, defaultValue = '' }) {
    const { answers } = useSelector(R.pick(['answers']));

    const [value, setValue] = useState(defaultValue);
    const [encryptedValue, setEncryptedValue] = useState('');

    const encryptValue = (value) => {
        if(value.length == 0) {
            return value;
        } else {
            const encrypted = CryptoJS.AES.encrypt(value, secretKey).toString();
        
            return encrypted;
        }
    }

    const decryptValue = (value) => {
        const decrypted = CryptoJS.AES.decrypt(value, secretKey).toString(CryptoJS.enc.Utf8);
        
        return decrypted;
    }

    useEffect(() => {
        if (answers?.find(q => q.qID == id)) {
            setValue(decryptValue(answers.find(q => q.qID == id).answer));
        }
    }, [])

    useEffect(() => {
        if (answers?.find(q => q.qID == id)) {
            setValue(decryptValue(answers.find(q => q.qID == id).answer));
        }
    }, [answers])

    const onChange = e => {
        const value = e.target.value;

        setValue(value);
        updateValue(id, encryptValue(value), true);
    }

    return (
        <div className="form-group">
            <label>{label}{required && <span className="required">*</span>}</label>
            <input type="text" className={`secure ${classes.join(" ")}`} id={id} autoFocus={autoFocus} onChange={onChange} value={value} placeholder={placeholder} name={name} />
            <Image className="secure_icon"><Image.Content src={lockImage} draggable="false"/></Image>
        </div>
    )
}